import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const quoteRestoreAtom = createMutationAtomFactory(
  'brokerage.quoteRestore',
  (params: { id: string }) => ({
    tradeQuoteRestore: {
      __args: {
        id: params.id,
      },
      id: true,
      status: true,
      timestamps: {
        updatedAt: true,
      },
    },
  }),
);
